"use client";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import List from "@/components/common/List";
import type { SingleLineMenu } from "../../types";
import { getMenuActiveItemIndex } from "../../utils/getMenuActiveItemIndex";
import MobileNavItem from "./MobileNavItem";
import s from "./MultiLevelNavDesktop.module.css";

export interface MultiLevelNavMobileProps {
  menuItems: SingleLineMenu;
}

export default function MultiLevelNavMobile(props: MultiLevelNavMobileProps) {
  const { menuItems } = props;
  const pathname = usePathname();

  const [openLevel1Index, setOpenLevel1Index] = useState(
    getMenuActiveItemIndex(pathname, menuItems),
  );

  useEffect(() => {
    const activeIndex = getMenuActiveItemIndex(pathname, menuItems);
    setOpenLevel1Index(activeIndex !== -1 ? activeIndex : openLevel1Index);
    // eslint-disable-next-line
  }, [pathname, menuItems]);

  return (
    <List
      items={menuItems}
      renderItem={(item, index) => (
        <MobileNavItem
          item={item}
          isOpen={openLevel1Index === index}
          // Function to handle exclusive opening (only one top-level item open at a time)
          onToggle={() =>
            setOpenLevel1Index(openLevel1Index === index ? -1 : index)
          }
        />
      )}
      variant="vertical"
      className={s.list}
    />
  );
}
